import {
  UPDATE_CHAT_TOTALS,
  UPDATE_CHAT_LIST,
  UPDATE_CHAT_LOADING,
  UPDATE_CHAT_ERROR,
  UPDATE_CHAT_ACTIVE,
  UPDATE_CHAT_MESSAGES,
  UPDATE_CHAT_CLIENT,
  UPDATE_CHAT_CLIENT_DATA,
  UPDATE_CHAT_NEW_MESSAGE,
  UPDATE_CHAT_REMOVE_MESSAGE,
  UPDATE_CHAT_ITEM_FAVORITE,
  UPDATE_CHAT_FILTER,
  UPDATE_CHAT_READ_MESSAGE,
  msgDirectionClientToUser,
  UPDATE_CHAT_EDIT_MESSAGE,
  UPDATE_CHAT_CHANGED_MESSAGE,
  UPDATE_CHAT_REPLY_MESSAGE,
  UPDATE_CHAT_ITEM_NEW,
  msgDirectionUserToClient,
  UPDATE_CHAT_REMINDER_NEW,
  UPDATE_CHAT_REMINDER_REMOVE,
  UPDATE_CHAT_ALERT,
  UPDATE_CHAT_CLIENT_REPORTS,
  UPDATE_CHAT_CLIENT_REPORT,
  UPDATE_CHAT_CLIENT_REPORT_ID,
  UPDATE_CHAT_SETTINGS,
  msgDirectionSystemToUser,
  UPDATE_CHAT_CLIENT_RELOAD,
  UPDATE_CHAT_REMINDER_EDIT,
  UPDATE_CHAT_TOTALS_RELOAD,
  msgDirectionNoteToClient,
  UPDATE_CHAT_UNANSWERED,
  UPDATE_CHAT_MESSAGES_LOADING,
  UPDATE_CHAT_CLIENT_NOTICE_ADD, UPDATE_CHAT_CLIENT_NOTICE_REMOVE,
  UPDATE_CHAT_CLIENT_ID,
  UPDATE_CHAT_CLIENT_CURATOR_DATA,
  UPDATE_CHAT_CLIENT_UNBAN_CHAT_MEMBER,
  UPDATE_PAGE,
  UPDATE_CHAT_CLEAR,
  UPDATE_CHAT_AI_BATCH,
  UPDATE_CHAT_AI_BATCH_CLEAR,
  UPDATE_CHAT_AI_CARD_EDIT
} from '../constants';

const  initialState = {
  totals: {},
  totalsReload: false,
  total: 0,
  filter: {
    search: '',
    period_type: '',
    period_from: '',
    period_to: '',
    length_msg: false,
    length_from: 0,
    length_to: 0,
    control: false,
    program_stage: -1,
    last_message: 0,
    added_to_chat: 0,
    archive: false,
    search_all: false,
    sort: 'new',
    tab: 'waiting'
  },
  reminders: [],
  list: [],
  messages: [],
  messages_offset: null,
  messages_total: null,
  messages_loading: null,
  edited: null,
  replied: null,
  client: null,
  clientReload: false,
  clientID: "",
  chatID: "",
  chatInfo: null,
  course: null,
  reports: null,
  reportID: "",
  report: null,
  notices: [],
  loading: false,
  errors: [],
  alert: null,
  settings: {},
  curator: null,
  responseillness: "",
  block_in_chat_boltalok_id_list: [],
  aiBatch: null,
  aiCardEdit: null
};

export default function chat(state = initialState, action) {
  switch (action.type) {
    // chat list filter is changed
    case UPDATE_CHAT_FILTER:
      return {
        ...state,
        filter: {
          ...state.filter,
          ...action.data
        }
      };
    // chat totals are received
    case UPDATE_CHAT_TOTALS:
      return {
        ...state,
        totals: action.totals,
        totalsReload: false
      };
    // chat totals are needed to reload
    case UPDATE_CHAT_TOTALS_RELOAD:
      return {
        ...state,
        totalsReload: true
      };
    // chat list is received
    case UPDATE_CHAT_LIST:
      return {
        ...state,
        list: action.list,
        total: action.total,
        reminds: action.reminds,
        loading: false,
        errors: []
      };
    // chat is selected
    case UPDATE_CHAT_ACTIVE:
      if (action.chat) {
        localStorage.setItem('dc_currentChat', JSON.stringify(action.chat));
      }
      return {
        ...state,
        clientID: action.chat ? action.chat.id : '',
        chatID: action.chat ? action.chat.chat_id : '',
        chatInfo: action.chat ? {
          postpone: action.chat.postpone,
          remind: action.chat.remind,
          time: action.chat.time,
          date_remind: action.chat.date_remind,
          unanswered_message: action.chat.unanswered_message
        } : null,
        client: null,
        clientReload: false,
        course: null,
        edited: null,
        replied: null,
        messages: [],
        messages_offset: null,
        messages_total: null,
        messages_loading: null,
        reports: null,
        reportID: "",
        report: null,
        notices: [],
        curator: null,
        responseillness: "",
        block_in_chat_boltalok_id_list: [],
        aiBatch: null,
        aiCardEdit: null
      };
    // client reports are received
    case UPDATE_CHAT_CLIENT_REPORTS:
      return {
        ...state,
        reports: action.items.map((i) => {
          return {
            ...i,
            created: i.created.split('T')[0].split('-').reverse().join('.')
          }
        })
      };
    // client report is selected
    case UPDATE_CHAT_CLIENT_REPORT_ID:
      return {
        ...state,
        reportID: action.reportID,
        report: null
      };
    // client report is received
    case UPDATE_CHAT_CLIENT_REPORT:
      return {
        ...state,
        report: action.item,
        reportID: action.item ? action.item.id : ''
      };
    // chat client profile is received
    case UPDATE_CHAT_CLIENT: {
      const client = action.client;
      const course = action.course;
      if (client && client.birthday) {
        client.birthday = client.birthday.split('T')[0];
        if (client.birthday.split('-')[0] === '0001') {
          client.birthday = '';
        }
      }
      if (course) {
        ['start_at', 'finish_at', 'start_at_part2', 'finish_at_part2', 'start_at_part3', 'finish_at_part3'].forEach((i) => {
          if (course[i] === '0001-01-01') {
            course[i] = '';
          }
        });
      }
      return {
        ...state,
        client: client,
        clientReload: false,
        course: course,
        notices: action.notices,
        curator: action.curator,
        responseillness: action.responseillness,
        block_in_chat_boltalok_id_list: action.block_in_chat_boltalok_id_list
      };
    }
    // chat client profile is updated
    case UPDATE_CHAT_CLIENT_DATA: {
      const changes = {
        client: {
          ...state.client,
          ...action.client
        }
      };
      if (action.client.hasOwnProperty('first_name')) {
        const ind = state.list.findIndex(i => i.id === action.client.id);
        if (ind > -1) {
          changes['list'] = state.list.slice();
          changes['list'][ind] = {...changes['list'][ind], ...action.client};
        }
      }
      return {
        ...state,
        ...changes
      };
    }
    // client is needed to reload
    case UPDATE_CHAT_CLIENT_RELOAD:
      return {
        ...state,
        clientReload: true
      };
    case UPDATE_CHAT_MESSAGES_LOADING:
      return {
        ...state,
        messages_loading: action.loading
      };
    // chat messages are received
    case UPDATE_CHAT_MESSAGES:
      return {
        ...state,
        messages: action.messages.reverse().concat(state.messages),
        messages_offset: action.offset,
        messages_total: action.total,
        messages_loading: false
      };
    // chat message is editing / chat message edit is canceled
    case UPDATE_CHAT_EDIT_MESSAGE:
      return {
        ...state,
        edited: action.message,
        replied: null
      };
    // chat message is being replied / chat message replying is canceled
    case UPDATE_CHAT_REPLY_MESSAGE:
      return {
        ...state,
        replied: action.message,
        edited: null
      };
    // chat message is updated (edited)
    case UPDATE_CHAT_CHANGED_MESSAGE: {
      const changes = {};
      const msg = action.message;
      if (state.chatID === msg.chat_id) {
        changes['messages'] = state.messages.map(i => {
          if (i.id === msg.id) {
            // reply_to_message is not filled when updated message comes via socket, 
            // so get it from the original message
            return {
              ...msg,
              reply_to_message: i.reply_to_message
            };
          }
          return i;
        });
      }
      if (state.filter.search !== '') {
        changes['totalsReload'] = true;
      }
      return {
        ...state,
        ...changes
      };
    }
    // chat is marked as answered
    case UPDATE_CHAT_UNANSWERED: {
      const changes = {
        totalsReload: true
      };
      let curChat = localStorage.getItem('dc_currentChat');
      curChat = curChat ? JSON.parse(curChat) : null;
      if (curChat && curChat.chat_id === action.id) {
        curChat.unanswered_message = false;
        localStorage.setItem('dc_currentChat', JSON.stringify(curChat));
      }
      if (state.chatID && state.chatID === action.id) {
        changes['chatInfo'] = {
          ...state.chatInfo,
          unanswered_message: false
        };
      }
      const ind = state.list.findIndex(i => i.chat_id === action.id);
      if (ind > -1) {
        changes['list'] = state.list.slice();
        if (state.filter.tab === 'waiting') {
          changes['list'].splice(ind, 1);
        } else {
          changes['list'][ind] = {...changes['list'][ind], unanswered_message: false};
        }
      }
      return {
        ...state,
        ...changes
      };
    }
    // new chat message is added
    case UPDATE_CHAT_NEW_MESSAGE: {
      const changes = {};
      const msg = action.message;
      if (state.chatID === msg.chat_id) {
        // add to chat messages list
        changes['messages'] = state.messages.slice();
        changes['messages'].push(msg);
        changes['messages_total'] = state.messages_total + 1;
        if (state.messages_offset > 0) {
          changes['messages_offset'] = state.messages_offset + 1;
        }
        if (msg.message_direction === msgDirectionSystemToUser) {
          changes['clientReload'] = true;
          changes['reports'] = null;
          changes['reportID'] = '';
        }
        if (msg.message_direction !== msgDirectionNoteToClient) {
          changes['chatInfo'] = {...changes['chatInfo'], unanswered_message: msg.message_direction === msgDirectionClientToUser ? true : false};
        }
      }

      if (msg.message_direction !== msgDirectionNoteToClient) {
        let curChat = localStorage.getItem('dc_currentChat');
        curChat = curChat ? JSON.parse(curChat) : null;
        if (curChat && curChat.chat_id === msg.chat_id) {
          curChat.unanswered_message = msg.message_direction === msgDirectionClientToUser ? true : false;
          localStorage.setItem('dc_currentChat', JSON.stringify(curChat));
        }
      }

      // update chat item in chat list and correct its position
      let list = state.list.slice();
      let totalsReload = false;
      if (state.filter.search !== '') {
        totalsReload = true;
      }
      if (msg.message_direction === msgDirectionSystemToUser) {
        totalsReload = true;
      }
      const ind = list.findIndex(i => i.chat_id === msg.chat_id);
      if (ind > -1) {
        const item = {...list[ind]};
        if (msg.message_direction !== msgDirectionNoteToClient) {
          item.unanswered_message = msg.message_direction === msgDirectionClientToUser ? true : false;
        }
        // recalc totals
        const prev_dt = new Date(item.last_messages.created);
        if (prev_dt && !totalsReload) {
          prev_dt.setHours(0, 0, 0, 0);
          const now_dt = new Date();
          now_dt.setHours(0, 0, 0, 0);
          if (prev_dt < now_dt) {
            // totals['today'] = totals['today'] + 1;
            totalsReload = true;
          }
          const yst_dt = new Date();
          yst_dt.setDate(yst_dt.getDate() - 1);
          yst_dt.setHours(0, 0, 0, 0);
          if (prev_dt === yst_dt) {
            // totals['yesterday'] = Math.max(0, totals['yesterday'] - 1);
            totalsReload = true;
          }
        }

        if (msg.message_direction === msgDirectionUserToClient) {
          if (item.last_messages &&
            (item.last_messages.message_direction === msgDirectionClientToUser || item.last_messages.message_direction === msgDirectionSystemToUser) &&
            !totalsReload) {
            // totals['waiting'] = Math.max(0, totals['waiting'] - 1);
            totalsReload = true;
          }
        }
        //changes['totals'] = totals;
        changes['totalsReload'] = totalsReload;
        list.splice(ind, 1);

        if (msg.message_direction === msgDirectionUserToClient && (state.filter.tab === 'waiting' || state.filter.tab === 'deferred')) {
          changes['list'] = list;

          return {
            ...state,
            ...changes
          };
        }

        item.last_messages = {
          id: msg.id,
          created: msg.created,
          message: msg.message,
          read_status: msg.read_status,
          message_direction: msg.message_direction
        };
        let new_ind = state.filter.tab !== 'waiting' || state.filter.sort === 'new' ? 0 : state.list.length;
        if (state.filter.period_from || state.filter.period_to) {
          const dt = new Date(msg.created.replace('Z', ''));
          if ((state.filter.period_from && new Date(state.filter.period_from + ' 00:00:00') > dt)
            || (state.filter.period_to && new Date(state.filter.period_to + ' 23:59:59') < dt)) {
            new_ind = -1;
          }
        }
        if (state.filter.length_msg) {
          if ((state.filter.length_from && msg.message.length < state.filter.length_from) ||
            (state.filter.length_to && msg.message.length > state.filter.length_to)) {
            new_ind = -1;
          }
        }
        if (new_ind > -1) {
          list.splice(new_ind, 0, item);
        }
        changes['list'] = list;
      } else {
        // chat not found, update filter to reload chat list
        changes['filter'] = {...state.filter};
        changes['totalsReload'] = false;
      }
      return {
        ...state,
        ...changes
      };
    }
    // chat message is removed
    case UPDATE_CHAT_REMOVE_MESSAGE: {
      const changes = {};
      changes['messages'] = state.messages.filter(i => i.id !== action.message_id);
      if (state.edited && state.edited.id === action.message_id) {
        changes['edited'] = null;
      }
      if (state.replied && state.replied.id === action.message_id) {
        changes['replied'] = null;
      }
      if (state.filter.search !== '') {
        changes['totalsReload'] = true;
      }
      return {
        ...state,
        ...changes
      };
    }
    // chat is added to / removed from favorites
    case UPDATE_CHAT_ITEM_FAVORITE: {
      const changes = {};
      if (state.client && state.client.id === action.id) {
        changes['client'] = {...state.client, is_favorites: action.is_favorites};
      }
      changes['list'] = state.list.map(item => {
        if (item.id === action.id) {
          item.is_favorites = action.is_favorites;
        }
        return item;
      });
      if (!action.is_favorites && state.filter.tab === 'favorite') {
        changes['list'] = changes['list'].filter(item => item.id !== action.id);
      }
      changes['totalsReload'] = true;
      return {
        ...state,
        ...changes
      };
    }
    // new chat is added
    case UPDATE_CHAT_ITEM_NEW: {
      if (state.filter.tab === 'all' || state.filter.tab === 'waiting') {
        if (state.filter.search !== '' || state.filter.program_stage > -1 || state.filter.last_message > 0 || state.filter.added_to_chat > 0 || state.filter.archive) {
          // reload list
          return {
            ...state,
            filter: {...state.filter}
          };
        }
        const item = action.item;
        const list = state.list.slice();
        let new_ind = state.filter.tab !== 'waiting' || state.filter.sort === 'new' ? 0 : state.list.length;
        if (state.filter.period_from || state.filter.period_to) {
          const dt = new Date(item.last_messages.created.replace('Z', ''));
          if ((state.filter.period_from && new Date(state.filter.period_from + ' 00:00:00') > dt)
            || (state.filter.period_to && new Date(state.filter.period_to + ' 23:59:59') < dt)) {
            new_ind = -1;
          }
        }
        if (state.filter.length_msg) {
          if ((state.filter.length_from && item.last_messages.message.length < state.filter.length_from) ||
            (state.filter.length_to && item.last_messages.message.length > state.filter.length_to)) {
            new_ind = -1;
          }
        }
        if (new_ind > -1) {
          list.splice(new_ind, 0, item);
        }
        return {
          ...state,
          list: list,
          totals: {
            ...state.totals,
            waiting: state.totals['waiting'] + 1,
            today: state.totals['today'] + 1
          }
        };
      }
      return state;
    }
    // chat message is read by user
    case UPDATE_CHAT_READ_MESSAGE: {
      const changes = {};
      const chat_id = action.chat_id;
      if (state.chatID === chat_id) {
        changes['messages'] = state.messages.map(i => {
          if (i.message_direction === msgDirectionClientToUser || i.message_direction === msgDirectionSystemToUser) {
            i.read_status = true;
          }
          return i;
        });
      }
      changes['list'] = state.list.map(item => {
        if (item.chat_id === chat_id && item.last_messages &&
          (item.last_messages.message_direction === msgDirectionClientToUser || item.last_messages.message_direction === msgDirectionSystemToUser) &&
          !item.last_messages.read_status) {
          return {
            ...item,
            last_messages: {
              ...item.last_messages,
              read_status: true
            }
          };
        }
        return item;
      });
      return {
        ...state,
        ...changes
      };
    }
    // chat reminder is edited
    case UPDATE_CHAT_REMINDER_EDIT: {
      const changes = {};
      if (action.item.postpone || action.item.remind) {
        // reminder added
        if (state.filter.tab === 'waiting') {
          const ind = state.list.findIndex(i => i.chat_id === action.item.id);
          if (ind > -1) {
            changes['list'] = state.list.slice();
            changes['list'].splice(ind, 1);
          }
        } else if (state.filter.tab === 'deferred') {
          // reload chat list
          changes['filter'] = {...state.filter};
        } else {
          const ind = state.list.findIndex(i => i.chat_id === action.item.id);
          if (ind > -1) {
            changes['list'] = state.list.slice();
            changes['list'][ind] = {...changes['list'][ind], postpone: action.item.postpone, remind: action.item.remind, time: action.item.time};
          }
        }
        if (!changes.hasOwnProperty('filter')) {
          changes['totalsReload'] = true;
        }
      } else {
        // reminder removed
        if (state.filter.tab === 'waiting') {
          // reload the list, so that the chat appears
          changes['filter'] = {...state.filter};
        } else if (state.filter.tab === 'deferred') {
          // remove from deferred
          const ind = state.list.findIndex(i => i.chat_id === action.item.id);
          if (ind > -1) {
            changes['list'] = state.list.slice();
            changes['list'].splice(ind, 1);
          }
        } else {
          const ind = state.list.findIndex(i => i.chat_id === action.item.id);
          if (ind > -1) {
            changes['list'] = state.list.slice();
            changes['list'][ind] = {...changes['list'][ind], postpone: action.item.postpone, remind: action.item.remind, time: action.item.time};
          }
        }
        if (!action.item.postpone && !action.item.remind && !changes.hasOwnProperty('filter')) {
          changes['totalsReload'] = true;
        }
      }
      changes['chatInfo'] = {
        postpone: action.item.postpone,
        remind: action.item.remind,
        time: action.item.time
      };
      return {
        ...state,
        ...changes
      };
    }
    // chat reminder is received
    case UPDATE_CHAT_REMINDER_NEW: {
      const changes = {};
      changes['reminders'] = [action.item].concat(state.reminders);
      if (state.filter.tab === 'waiting') {
        // reload the list, so that the chat appears
        changes['filter'] = {...state.filter};
      } else if (state.filter.tab === 'deferred') {
        // remove from deferred
        const ind = state.list.findIndex(i => i.chat_id === action.item.chat_id);
        if (ind > -1) {
          changes['list'] = state.list.slice();
          changes['list'].splice(ind, 1);
        }
      } else {
        const ind = state.list.findIndex(i => i.chat_id === action.item.chat_id);
        if (ind > -1) {
          changes['list'] = state.list.slice();
          changes['list'][ind] = {...changes['list'][ind], remind: false, time: 0};
        }
      }
      if (!action.item.postpone && !action.item.remind && !changes.hasOwnProperty('filter')) {
        changes['totalsReload'] = true;
      }
      if (state.chatID === action.item.chat_id) {
        changes['chatInfo'] = {
          postpone: action.item.postpone,
          remind: action.item.remind,
          time: action.item.time
        };
      }

      return {
        ...state,
        ...changes
      };
    }
    // chat reminder is removed (clicked on)
    case UPDATE_CHAT_REMINDER_REMOVE: {
      let reminders = state.reminders.slice();
      const ind = reminders.findIndex(i => i.chat_id === action.chat_id);
      if (ind > -1) {
        reminders.splice(ind, 1);
        return {
          ...state,
          reminders
        };
      }
      return state;
    }
    case UPDATE_CHAT_CLIENT_NOTICE_ADD: {
      let notices = state.notices;
      let find = false;

      state.notices.forEach(function (value, index){
        if(value.id === action.item.id){
          notices[index] = action.item;
          find = true;
        }
      });

      if(!find){
        notices = [action.item].concat(state.notices)
      }

      return {
        ...state,
        notices: notices
      };
    }
    case UPDATE_CHAT_CLIENT_NOTICE_REMOVE: {
      return {
        ...state,
        notices: state.notices.filter((i) => i.id !== action.id)
      };
    }
    // chat alert sound is needed to play
    case UPDATE_CHAT_ALERT:
      return {
        ...state,
        alert: action.alert
      };
    // chat settings are updated
    case UPDATE_CHAT_SETTINGS:
      const new_settings = {...state.settings, ...action.settings};
      localStorage.setItem('dc_currentChatSettings', JSON.stringify(new_settings));
      return {
        ...state,
        settings: new_settings
      };
    // chat loading state is updated
    case UPDATE_CHAT_LOADING:
      return {
        ...state,
        loading: action.loading,
        errors: action.errors || []
      };
    // chat error is updated
    case UPDATE_CHAT_ERROR:
      return {
        ...state,
        loading: false,
        errors: action.errors
      };
    case UPDATE_CHAT_CLIENT_ID:
      localStorage.removeItem('dc_currentChat');
      return {
        ...state,
        clientID: ''
      };
    case UPDATE_CHAT_CLIENT_CURATOR_DATA: {
      const changes = {
        curator: {
          ...state.curator,
          ...action.curator
        }
      };
      return {
        ...state,
        ...changes
      };
    };
    case UPDATE_CHAT_CLIENT_UNBAN_CHAT_MEMBER: {
      return {
        ...state,
        block_in_chat_boltalok_id_list: action.block_in_chat_boltalok_id_list
      };
    };
    case UPDATE_PAGE: {
        window.location.reload();
    };
    case UPDATE_CHAT_CLEAR: {
      return {
        ...initialState
      };
    }
    case UPDATE_CHAT_AI_BATCH:
      // A batch belongs to one client: a response, or a restore after a failed send, can land
      // after the chat has been switched. While the next client's profile loads state.client is
      // null — writing is forbidden in that window too, otherwise a foreign suggestion waits for
      // the load and shows up on the new client's card. Without client_id behaviour is unchanged.
      if (action.client_id && (!state.client || String(state.client.id) !== String(action.client_id))) {
        return state;
      }
      return {
        ...state,
        aiBatch: action.data
      };
    case UPDATE_CHAT_AI_BATCH_CLEAR:
      // Only whoever consumed the batch may dismiss it: a send callback can land after a switch
      // to another client and would wipe that client's suggestion.
      // Without client_id (old UI, aiBatchGetAction) behaviour is unchanged.
      if (action.client_id && state.client && String(state.client.id) !== String(action.client_id)) {
        return state;
      }
      return {
        ...state,
        aiBatch: null,
        aiCardEdit: null
      };
    case UPDATE_CHAT_AI_CARD_EDIT:
      // Same ownership check as the batch: a restore after a failed send can land once the chat
      // has already been switched, and the edit chip would show up on another client.
      // Without client_id (entering and leaving edit mode) behaviour is unchanged.
      if (action.client_id && (!state.client || String(state.client.id) !== String(action.client_id))) {
        return state;
      }
      return {
        ...state,
        aiCardEdit: action.data
      };
    default:
      return state;
  }
}
